function domain() {
  // return "http://localhost:3000/"
  return "https://business.strackit.com/";
}

export default domain;
